import castleSmall from "../assets/optimized/13-480.jpg";
import castle from "../assets/optimized/13-1280.jpg";
import ballpitSmall from "../assets/optimized/8-480.jpg";
import ballpit from "../assets/optimized/8-1280.jpg";
import ridesSmall from "../assets/optimized/19-480.jpg";
import rides from "../assets/optimized/19-1280.jpg";
import ridingSmall from "../assets/optimized/1-480.jpg";
import riding from "../assets/optimized/1-1280.jpg";
import pizzaSmall from "../assets/optimized/6-480.jpg";
import pizza from "../assets/optimized/6-1280.jpg";
import tunnelSmall from "../assets/optimized/12-480.jpg";
import tunnel from "../assets/optimized/12-1280.jpg";

export const venuePhotos = [
  {
    src: castle,
    small: castleSmall,
    alt: "Pastel castle play structure with rainbow windows and a blue slide at Kiddie Kingdom",
    caption: "A kingdom of their own",
    width: 2366,
    height: 3543,
  },
  {
    src: ballpit,
    small: ballpitSmall,
    alt: "Pink and blue ball pit, candy-striped play features, and a tube tunnel",
    caption: "Dive into the fun",
    width: 2486,
    height: 3722,
  },
  {
    src: rides,
    small: ridesSmall,
    alt: "Pastel padded animal rides in front of the indoor play structure",
    caption: "Little adventures await",
    width: 2832,
    height: 4240,
  },
  {
    src: riding,
    small: ridingSmall,
    alt: "Child enjoying a pink padded ride in the Kiddie Kingdom play area",
    caption: "Room for big smiles",
    width: 2698,
    height: 4040,
  },
  {
    src: pizza,
    small: pizzaSmall,
    alt: "Child enjoying pizza at a table in the party seating area",
    caption: "A pause for party time",
    width: 2832,
    height: 4240,
  },
  {
    src: tunnel,
    small: tunnelSmall,
    alt: "Child exploring a colorful circular opening in the soft play structure",
    caption: "Play their own way",
    width: 2832,
    height: 4240,
  },
];
